import styled from 'styled-components';

const ModalFooter = styled.div`
  padding: 16px 32px;
  text-align: right;
  border-top: ${({ theme }) => `${theme.border.width.small} solid ${theme.border.color.dark}`};
`;

export default ModalFooter;
